// removed by extract-text-webpack-plugin
module.exports = {"block":"_3tHB9oh_OVm2KZDqvJQpwo","modal":"lB_5fBWpxc9nTxB1L-wPn","wrapper":"_19bIVVfvtfY39JuTqXZxvK","buttonWrapper":"_3iwYYr8KZV1nm4bSgFoKuD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyInPropertiesList/CompanyBlock/CompanyBlock.scss
// module id = 1590
// module chunks = 0